import React from 'react';
import {operators, TableDetails, TableInput, useTableCreation} from '../../TableTemplate';
import { ExclusionGroupLink } from '../../TableItemLink';
import { ExclusionGroupName } from '../../../backend/model';

const TABLE_ID = 'exclusionGroupsTable';

const COLUMN_DEFINITIONS = [
    {
        id: 'name',
        header: 'Name',
        cell: (exclusionGroup: ExclusionGroupName) => <ExclusionGroupLink exclusionGroupName={exclusionGroup.name} />,
        sortingField: "name"
    },
];

const FILTERING_PROPERTIES = [
    {
        propertyLabel: 'Name',
        key: 'name',
        groupValuesLabel: 'Exclusion Group Name',
        operators: operators,
    },
];

const ExclusionGroupsTable: React.FC<TableInput> = ({tableItems, fileName}) => {
    const tableDetails: TableDetails = {
        tableId: TABLE_ID,
        header: '',
        fileName: fileName,
        getRow: function (row: any): string[] {
            return [row.name];
        },
    };
    return useTableCreation(tableDetails, COLUMN_DEFINITIONS, tableItems, FILTERING_PROPERTIES);
};

export default ExclusionGroupsTable;
